var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-textarea"},[_c('el-input',{staticClass:"el-textarea__input",class:{ 'el-textarea__input--prefix': _vm.prefixIcon },attrs:{"type":"textarea","autosize":{ minRows: _vm.minRows, maxRows: _vm.maxRows },"resize":"none","placeholder":_vm.placeholder},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}}),(_vm.prefixIcon)?_c('i',{staticClass:"el-textarea__icon",class:( _obj = {
      'el-textarea__icon--empty': !_vm.cleanModel.length
    }, _obj[_vm.prefixIcon] = true, _obj )}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }